import "./EditPositionType.css";
import { useAppState } from "../../../utils/appState";
import { useState } from "react";
import { ReactComponent as TimesIcon } from "../../../icons/times.svg";
import { Loader } from "../../common";
import { useMutation } from "@apollo/client";
import { UPDATE_SPORT } from "../../../api/sports";

export default function EditPositionType({ pos, sport, groups }) {
  const [, setAppState] = useAppState();
  const [error, setError] = useState("");
  const [name, setName] = useState(pos.name);
  const [shortName, setShortName] = useState(pos.shortName);
  const [groupId, setGroupId] = useState(pos.group?.id || "");

  const [mutate, mutation] = useMutation(
    UPDATE_SPORT({
      selectionSet: `
      positionTypes{
        id
        name
        shortName
        group{
          id
          name
        }
        canDelete
      }
  `,
    }),
    {
      update: () => {
        setAppState({ modal: false });
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return (
    <div className="App-modal-form">
      <div className="App-modal-form__header">
        <div className="App-modal-form__header__title">Create Position</div>

        <div
          className="App-modal-form__header__dismiss"
          onClick={() => {
            setAppState({ modal: false });
          }}
        >
          <TimesIcon className="App-modal-form__header__dismiss__icon" />
        </div>
      </div>

      <form
        className="App-modal-form__body"
        onSubmit={(e) => {
          e.preventDefault();

          if (mutation.loading) return;

          setError("");

          if (!name || !shortName || !groupId) {
            setError("All fields are required.");
            return;
          }

          const vars = {
            where: { id: sport.id },
            data: {
              positionTypes: {
                update: [
                  { where: { id: pos.id }, data: { name, shortName, groupId } },
                ],
              },
            },
          };

          mutate({
            variables: vars,
          });
        }}
      >
        <div className="App-modal-form__body__group">
          <div className="App-modal-form__body__group__label">
            Name<span className="required">*</span>
          </div>

          <div className="App-modal-form__body__group__input">
            <input
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="App-modal-form__body__group__input__text"
            />
          </div>
        </div>

        <div className="App-modal-form__body__group">
          <div className="App-modal-form__body__group__label">
            Short Name<span className="required">*</span>
          </div>

          <div className="App-modal-form__body__group__input">
            <input
              type="text"
              value={shortName}
              onChange={(e) => {
                setShortName(e.target.value);
              }}
              className="App-modal-form__body__group__input__text"
            />
          </div>
        </div>

        <div className="App-modal-form__body__group">
          <div className="App-modal-form__body__group__label">
            Group<span className="required">*</span>
          </div>

          <div className="App-modal-form__body__group__input">
            <select
              className="App-modal-form__body__group__input__select"
              value={groupId}
              onChange={(e) => {
                setGroupId(e.target.value);
              }}
            >
              <option value=""></option>
              {groups.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {error && <div className="App-modal-form__body__error">{error}</div>}

        <button
          type="submit"
          className={
            "App-button App-modal-form__body__submit-btn " +
            (mutation.loading ? "loading" : "")
          }
        >
          {mutation.loading ? <Loader theme="small" /> : "SUBMIT"}
        </button>
      </form>
    </div>
  );
}
